import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import { fetchSlotsOpenUrlAction } from '../../../store/apiActions/fetchSlotsOpenUrlAction';

const initialState: {
  isIframeLoaded: boolean;
  isLobbyFullscreen: boolean;
  isSlotsLobbyLoading: boolean;
  isSlotsLobbyHasError: boolean;
  slotsLobbyErrorCount: number;
} = {
  isIframeLoaded: false,
  isLobbyFullscreen: false,
  isSlotsLobbyLoading: false,
  isSlotsLobbyHasError: false,
  slotsLobbyErrorCount: 0,
};

export const miniLobbySlice = createSlice({
  name: 'minilobby',
  initialState,
  reducers: {
    setIsIframeLoaded: (state, action: PayloadAction<boolean>) => {
      state.isIframeLoaded = action.payload;
    },
    setIsLobbyFullscreen: (state, action: PayloadAction<boolean>) => {
      state.isLobbyFullscreen = action.payload;
    },
    reSetSlotsLobbyError: (state) => {
      state.isSlotsLobbyHasError = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchSlotsOpenUrlAction.pending, (state) => {
      state.isSlotsLobbyLoading = true;
    });
    builder.addCase(fetchSlotsOpenUrlAction.rejected, (state) => {
      state.isSlotsLobbyLoading = false;
      state.isSlotsLobbyHasError = true;
      state.slotsLobbyErrorCount += 1;
    });
  },
});

export const miniLobbyActions = miniLobbySlice.actions;
